import { render, staticRenderFns } from "./ViewSettingsUserClients.vue?vue&type=template&id=2bb70688&scoped=true&"
import script from "./ViewSettingsUserClients.vue?vue&type=script&lang=js&"
export * from "./ViewSettingsUserClients.vue?vue&type=script&lang=js&"
import style0 from "./ViewSettingsUserClients.vue?vue&type=style&index=0&id=2bb70688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb70688",
  null
  
)

export default component.exports